import React, { useCallback, useState } from 'react';
import useCollectionState from 'Hooks/useCollectionState';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import DataContainer from 'Components/UI/DataContainer';
import PropTypes from 'prop-types';
import LeadPromos from './LeadPromos';

export function LeadPromosContainer({ relationshipLink }) {
  const { refreshPageContentCollection } = usePageContentContext();
  const {
    collection,
    isInitializing,
    loadingError,
    setCollection,
    refreshCollection: refreshInnerCollection,
  } = useCollectionState({ link: relationshipLink.link('related').url() });


  const [loading, setLoading] = useState(false);

  const refreshCollection = useCallback(async () => {
    setLoading(true);
    try {
      await Promise.all([
        refreshInnerCollection(),
        refreshPageContentCollection(),
      ]);
      setLoading(false);
    } catch (e) {
      setLoading(false);
      throw e;
    }
  }, [refreshInnerCollection, refreshPageContentCollection]);

  return (
    <DataContainer
      loading={isInitializing}
      loadingError={loadingError}
      component={LeadPromos}
      componentProps={{
        loading,
        setLoading,
        collection,
        setCollection,
        refreshCollection,
      }}
    />
  );
}

LeadPromosContainer.propTypes = {
  relationshipLink: PropTypes.object.isRequired,
};
